import { put, select, takeLatest } from 'redux-saga/effects'
import { getPnMedicationSelector } from '../selectors/pnMedication.selector'
import { setAddMedicationAdministeredData } from '../store/pnMedication.actions'
import { PnMedicationConstants } from '../store/pnMedication.constants'
import { IPnMedicationState } from '../store/pnMedication.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { throwPcrException } from '../../../pcr/store/pcr.actions'

export function* deletePnMedication() {
  const pnMedicationState: IPnMedicationState = yield select(getPnMedicationSelector)
  try {
    const { pnMedication, addMedicationAdministeredData } = pnMedicationState
    if (pnMedication && addMedicationAdministeredData) {
      yield put(
        setAddMedicationAdministeredData(
          addMedicationAdministeredData?.filter((medication) => medication.id !== pnMedication?.id)
        )
      )
    }
  } catch (e) {
    yield put(throwPcrException(`deletePnMedication() error: ${e}`))
  }
}
export function* deletePnMedicationSaga() {
  yield takeLatest([PnMedicationConstants.DELETE_PN_MEDICATION], performWithMutexHOG, deletePnMedication)
}
